import { KpiType } from "../../../../../components/features/PrimaryKpiCard"
import { Units } from "../../../../../redux/global/globalTypes"
import { EnvName, KPI } from "../../../../../redux/user/userTypes"
import { ConfigKPIs } from "./FsKpis"

export enum TooltipsKPIs {
    WAREHOUSES = `Nombre total de dépôts ayant distribué au moins une de vos références et variation par rapport à l'année précédente.`,
    PRODUCTS = `Nombre de références vendues sur la période sélectionnée et variation par rapport à l'année précédente`,
    VMM = `Ventes moyennes mensuelles : indication en volume de la rotation de vos produits et variation par rapport à l'année précédente.`,
    VOLUME = `Volume total livré sur la période sélectionnée et variation par rapport à l'année précédente.`,
    CLIENTS = `Nombre total des utilisateurs finaux ayant acheté au moins une de vos références et variation par rapport à l'année précédente.`,
    PDV = `Nombre total des points de ventes ayant vendu au moins une de vos références et variation par rapport à l'année précédente.`,
    SHARE = `Parts de marché et variation par rapport à l'année précédente.`,
    VOLUME_SELL_IN_PROMO = `Volume sell-in promotionné livré au distributeur et son évolution par rapport à A-1.`,
    VOLUME_SELL_IN_GLOBAL = `Volume sell-in total livré au distributeur et son évolution par rapport à A-1.`,
    VOLUME_SELL_OUT = `Volume sell-out total distribué par le distributeur (sortie de dépôt) et son évolution par rapport à A-1.`,
    BUDGET = `Budget total déclaré et budget investi dans de la promotion sur la période A.`
}

export interface KPIProps {
    KPIs: KPI;
    envName: EnvName;
    unit: Units;
    companyName: string
}

export const KPIsCercleVertConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.kg,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVolume
        },
        {
            id: 2,
            name: 'Références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: Math.round(KPIs.products),
            difference: KPIs.products - KPIs.productsLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionProducts
        },
    ]


export const KPIsEpiSaveursConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.kg,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVolume
        },
        {
            id: 2,
            name: 'Références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: Math.round(KPIs.products),
            difference: KPIs.products - KPIs.productsLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionProducts
        },
        {
            id: 3,
            name: 'VMM',
            units: Units.kgPerWarehouse,
            description: TooltipsKPIs.VMM,
            number: Math.round(KPIs.vmm),
            difference: KPIs.differenceVmm,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVmm
        },
        {
            id: 4,
            name: 'Dépôts',
            units: Units.warehouses,
            description: TooltipsKPIs.WAREHOUSES,
            number: KPIs.warehouses,
            difference: KPIs.differenceWarehouses,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionWarehouses
        },
    ]


export const KPIsPassionFroidConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.kg,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVolume
        },
        {
            id: 2,
            name: 'Références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: Math.round(KPIs.products),
            difference: KPIs.products - KPIs.productsLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionProducts
        },
        {
            id: 3,
            name: 'Dépôts',
            units: Units.warehouses,
            description: TooltipsKPIs.WAREHOUSES,
            number: KPIs.warehouses,
            difference: KPIs.warehouses - KPIs.warehousesLastYear,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionWarehouses
        },
    ]

export const KPIsSodexoConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.kg,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVolume
        },
        {
            id: 2,
            name: 'Références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: Math.round(KPIs.products),
            difference: KPIs.products - KPIs.productsLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionProducts
        },
    ]

export const KPIsTGMConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => {
    return [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.kg,
            description: `Total des volumes facturés sur la période sélectionnée et variation par rapport à l’année précédente.`,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVolume
        },
        {
            id: 2,
            name: 'Références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: Math.round(KPIs.products),
            difference: KPIs.products - KPIs.productsLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionProducts
        },
        {
            id: 3,
            name: 'Dépôts',
            units: Units.warehouses,
            description: `Nombre total de points de vente finaux ayant distribué vos références sur la période sélectionnée et variation par rapport à l'année précédente.`,
            number: KPIs.warehouses ? KPIs.warehouses : 0,
            difference: KPIs.warehouses ? KPIs.warehouses - KPIs.warehousesLastYear : 0,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionWarehouses
        },
    ]
}


export const KPIsFFRConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.kg,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVolume
        },
        {
            id: 2,
            name: `Nombre d'utilisateurs finaux`,
            units: Units.clients,
            description: TooltipsKPIs.CLIENTS,
            number: KPIs.clients,
            difference: KPIs.clients - KPIs.clientsLastYear,
            route: `/food-service/${envName}/clients`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionClients
        },
        {
            id: 3,
            name: 'VMM',
            units: Units.kgPerWarehouse,
            description: TooltipsKPIs.VMM,
            number: Math.round(KPIs.vmm),
            difference: KPIs.differenceVmm,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVmm
        },
        {
            id: 4,
            name: 'Dépôts',
            units: Units.warehouses,
            description: TooltipsKPIs.WAREHOUSES,
            number: KPIs.warehouses,
            difference: KPIs.differenceWarehouses,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionWarehouses
        },
    ]

export const KPIsTGMPlusConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.kg,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolution: KPIs.evolutionVolume,
            evolutionUnit: Units.percent,
        },
        {
            id: 2,
            name: `Utilisateurs finaux`,
            units: Units.clients,
            description: TooltipsKPIs.CLIENTS,
            number: KPIs.clients,
            number2: Math.round(KPIs.transactions),
            difference: KPIs.clients - KPIs.clientsLastYear,
            difference2: KPIs.transactions - KPIs.transactionsLastYear,
            route: `/food-service/${envName}/clients`,
            evolution: KPIs.evolutionClients,
            evolution2: KPIs.evolutionTransactions,
            evolutionUnit: Units.percent,
            evolution2Unit: Units.percent,
        },
        {
            id: 3,
            name: 'VMM',
            units: Units.kgPerWarehouse,
            description: TooltipsKPIs.VMM,
            number: Math.round(KPIs.vmm),
            difference: KPIs.vmm - KPIs.vmmLastYear,
            route: `/food-service/${envName}/produits`,
            evolution: KPIs.evolutionVmm,
            evolutionUnit: Units.percent,
        },
        {
            id: 4,
            name: 'Dépôts',
            units: Units.warehouses,
            description: TooltipsKPIs.WAREHOUSES,
            number: KPIs.warehouses,
            difference: KPIs.warehouses - KPIs.warehousesLastYear,
            route: `/food-service/${envName}/depots`,
            evolution: KPIs.evolutionWarehouses,
            evolutionUnit: Units.percent,
        },
    ]

export const KPIsGBHConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.euro,
            units2: Units.uvc,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.ca),
            number2: Math.round(KPIs.volume),
            difference: KPIs.differenceCa,
            difference2: KPIs.differenceVolume,
            route: `/food-service/${envName}/produits`,
            evolution: Math.round(KPIs.evolutionCA),
            evolution2: Math.round(KPIs.evolutionVolume),
            evolutionUnit: Units.percent,
            evolution2Unit: Units.percent,
            type: KpiType.DOUBLE,
            unitType: Units.ca,
            unitType2: Units.volume
        },
        {
            id: 2,
            name: `Nombre de points de vente (DN)`,
            units: Units.pdv,
            description: TooltipsKPIs.PDV,
            number: KPIs.warehouses,
            difference: KPIs.differenceWarehouses,
            route: `/food-service/${envName}/pointsdevente`,
            evolution: KPIs.evolutionWarehouses,
            evolutionUnit: Units.percent,
        },
        {
            id: 3,
            name: 'Parts de marché JPB',
            units: Units.percent,
            units2: Units.percent,
            description: TooltipsKPIs.SHARE,
            number: Math.round(KPIs.shareCa),
            number2: Math.round(KPIs.shareVolume),
            difference: KPIs.differenceShareCa,
            difference2: KPIs.differenceShareVolume,
            differenceUnit: Units.point,
            difference2Unit: Units.point,
            route: `/food-service/${envName}/fournisseurs`,
            type: KpiType.DOUBLE,
            unitType: Units.ca,
            unitType2: Units.volume,
        },
        {
            id: 4,
            name: 'Nombre de références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: KPIs.products,
            difference: KPIs.differenceProducts,
            route: `/food-service/${envName}/produits`,
            evolution: Math.round(KPIs.evolutionProducts),
            evolutionUnit: Units.percent,
            evolution2Unit: Units.point,
        },
    ]

export const KPIsCVRPDMConfig = ({
    KPIs,
    envName,
    companyName
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.euro,
            units2: Units.uvc,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.ca),
            number2: Math.round(KPIs.volume),
            difference: KPIs.differenceCa,
            difference2: KPIs.differenceVolume,
            route: `/food-service/${envName}/produits`,
            evolution: Math.round(KPIs.evolutionCA),
            evolution2: Math.round(KPIs.evolutionVolume),
            evolutionUnit: Units.percent,
            evolution2Unit: Units.percent,
            type: KpiType.DOUBLE,
            unitType: Units.ca,
            unitType2: Units.volume
        },
        {
            id: 3,
            name: `Parts de marché ${companyName}`,
            units: Units.percent,
            units2: Units.percent,
            description: TooltipsKPIs.SHARE,
            number: Math.round(KPIs.shareCa),
            number2: Math.round(KPIs.shareVolume),
            difference: KPIs.differenceShareCa,
            difference2: KPIs.differenceShareVolume,
            differenceUnit: Units.point,
            difference2Unit: Units.point,
            route: `/food-service/${envName}/fournisseurs`,
            type: KpiType.DOUBLE,
            unitType: Units.ca,
            unitType2: Units.volume,
        },
        {
            id: 4,
            name: 'Nombre de références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: KPIs.products,
            difference: KPIs.differenceProducts,
            route: `/food-service/${envName}/produits`,
            evolution: Math.round(KPIs.evolutionProducts),
            evolutionUnit: Units.percent,
            evolution2Unit: Units.point,
        },
    ]

export const KPIsMetroConfig = ({
    KPIs,
    envName,
    unit
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: unit === Units.uvc ? Units.uvc : Units.kg,
            description: `Volume total livré sur la période sélectionnée et variation par rapport à l'année précédente.`,
            number: Math.round(KPIs.volume),
            difference: KPIs.volume - KPIs.volumeLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVolume
        },
        {
            id: 2,
            name: 'Dépôts',
            units: Units.warehouses,
            description: TooltipsKPIs.WAREHOUSES,
            number: KPIs.warehouses,
            difference: KPIs.differenceWarehouses,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionWarehouses
        },
        {
            id: 3,
            name: 'VMM par dépôt',
            units: unit === Units.uvc ? Units.uvcPerWarehouse : Units.kgPerWarehouse,
            description: TooltipsKPIs.VMM,
            number: Math.round(KPIs.vmm),
            difference: KPIs.differenceVmm,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionVmm
        },
        {
            id: 4,
            name: 'Références distribuées',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: Math.round(KPIs.products),
            difference: KPIs.products - KPIs.productsLastYear,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: KPIs.evolutionProducts
        },
    ]

export const KPIsC10AndDistriboissonsConfig = ({
    KPIs,
    envName,
}: KPIProps): ConfigKPIs[] => [
        {
            id: 1,
            name: 'Volume sell-out total',
            units: Units.liter,
            units2: Units.uvc,
            description: TooltipsKPIs.VOLUME,
            number: Math.round(KPIs.volume),
            number2: Math.round(KPIs.unitVolume),
            difference: KPIs.differenceVolume,
            difference2: KPIs.differenceUnitVolume,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: Math.round(KPIs.evolutionVolume),
            evolution2: Math.round(KPIs.evolutionUnitVolume),
            evolution2Unit: Units.percent,
            type: KpiType.DOUBLE
        },
        {
            id: 2,
            name: `Dépôts`,
            units: Units.warehouses,
            description: TooltipsKPIs.WAREHOUSES,
            number: KPIs.warehouses,
            difference: KPIs.differenceWarehouses,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution: Math.round(KPIs.evolutionWarehouses)
        },
        {
            id: 3,
            name: 'VMM par dépôt',
            units: Units.literPerWarehouse,
            units2: Units.uvcPerWarehouse,
            description: TooltipsKPIs.VMM,
            number: Math.round(KPIs.vmmVolume),
            number2: Math.round(KPIs.vmmUnitVolume),
            difference: KPIs.differenceVmmVolume,
            difference2: KPIs.differenceVmmUnitVolume,
            route: `/food-service/${envName}/depots`,
            evolutionUnit: Units.percent,
            evolution2Unit: Units.percent,
            evolution: Math.round(KPIs.evolutionVmmVolume),
            evolution2: Math.round(KPIs.evolutionVmmUnitVolume),
            type: KpiType.DOUBLE,
        },
        {
            id: 4,
            name: 'Nombre de références',
            units: Units.references,
            description: TooltipsKPIs.PRODUCTS,
            number: KPIs.products,
            difference: KPIs.differenceProducts,
            route: `/food-service/${envName}/produits`,
            evolutionUnit: Units.percent,
            evolution: Math.round(KPIs.evolutionProducts)
        },


    ]